import { normalizeSliderRange, type SliderRange } from '@/core/components/CustomSlider/CustomSlider';

export interface RangePayload {
  value: {
    gte?: string;
    lte?: string;
  };
}

export const buildRangePayload = (
  range: SliderRange,
  min: number,
  max: number,
): RangePayload | undefined => {
  const [lower, upper] = normalizeSliderRange(range);

  const value = {
    ...(lower > min ? { gte: String(lower) } : {}),
    ...(upper < max ? { lte: String(upper) } : {}),
  };

  const hasFilter = Object.keys(value).length > 0;

  return hasFilter ? { value } : undefined;
};
